"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePermissions = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
function loadPermissionsFromBackend(ctx) {
    var backend = ctx.backend, workspace = ctx.workspace;
    return backend.workspace(workspace).permissions().getPermissionsForCurrentUser();
}
function resolvePermissions(ctx, cmd) {
    var permissions, result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                permissions = cmd.payload.permissions;
                if (permissions) {
                    return [2 /*return*/, permissions];
                }
                return [4 /*yield*/, effects_1.call(loadPermissionsFromBackend, ctx)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
exports.resolvePermissions = resolvePermissions;
//# sourceMappingURL=resolvePermissions.js.map